import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { CertAPI } from '../lib/api';
import { Table, Thead, Tbody, Th, Tr, Td } from '../components/ui/Table';
import { Badge } from '../components/ui/Badge';
import { CertCard } from '../components/CertCard';
import { Skeleton } from '../components/ui/Skeleton';
import { TopBar } from '../components/TopBar';
import { formatDate } from '../lib/format';

export function CertsPage() {
  const { data: certsData, isLoading } = useQuery({
    queryKey: ['certs'],
    queryFn: CertAPI.list,
    refetchInterval: 60000,
  });

  const certs: any[] = certsData?.items ?? certsData ?? [];

  return (
    <div>
      <TopBar title="SSL Сертифікати" />
      <div className="p-6">
        {isLoading ? (
          <div className="space-y-2">
            {[1,2,3].map(i => <Skeleton key={i} className="h-12 w-full" />)}
          </div>
        ) : certs.length > 0 ? (
          <Table>
            <Thead>
              <Tr>
                <Th>Домен</Th>
                <Th>Issuer</Th>
                <Th>Закінчується</Th>
                <Th>Лишилось</Th>
                <Th>Авто-оновлення</Th>
                <Th>Дії</Th>
              </Tr>
            </Thead>
            <Tbody>
              {certs.map((cert: any) => {
                const daysLeft = cert.daysLeft ?? 0;
                const daysVariant = daysLeft < 14 ? 'error' : daysLeft < 30 ? 'warning' : 'success';
                return (
                  <Tr key={cert.domain}>
                    <Td className="font-medium">{cert.domain}</Td>
                    <Td className="text-tg-text-secondary">{cert.issuer || '—'}</Td>
                    <Td className="text-tg-text-secondary text-xs">
                      {cert.expiresAt ? formatDate(cert.expiresAt) : '—'}
                    </Td>
                    <Td>
                      <Badge variant={daysVariant}>{daysLeft}д</Badge>
                    </Td>
                    <Td>
                      <Badge variant={cert.autoRenew ? 'success' : 'muted'}>
                        {cert.autoRenew ? 'Так' : 'Ні'}
                      </Badge>
                    </Td>
                    <Td>
                      <CertCard cert={cert} />
                    </Td>
                  </Tr>
                );
              })}
            </Tbody>
          </Table>
        ) : (
          <div className="text-center py-12 text-tg-text-secondary">
            Сертифікати не знайдені
          </div>
        )}
      </div>
    </div>
  );
}
